"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationRules = void 0;

var _validator = require("../validator");

var _usersI18n = require("./users-i18n");

var _messagesI18n = require("../messages-i18n");

var userValidationRules = function userValidationRules(_) {
  return [{
    attributes: ['email', 'name', 'roles'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['create']
  }, {
    attributes: ['name', 'roles'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['update']
  }, {
    attributes: ['password', 'confirmPassword'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['create', 'change_password']
  }, {
    attributes: ['oldPassword'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['change_password']
  }, {
    attributes: ['email'],
    condition: _validator.EMAIL,
    message: _(_usersI18n.messages.emailDoesNotMatchThePattern),
    on: ['create', 'update']
  }, {
    attributes: ['confirmPassword'],
    condition: _validator.COMPARE,
    compareAttribute: 'password',
    message: _(_usersI18n.messages.fieldsMustMatch, {
      field1: _(_usersI18n.messages.password),
      field2: _(_usersI18n.messages.confirmPassword)
    }),
    on: ['create']
  }, {
    attributes: ['confirmPassword'],
    condition: _validator.COMPARE,
    compareAttribute: 'password',
    message: _(_usersI18n.messages.fieldsMustMatch, {
      field1: _(_usersI18n.messages.newPassword),
      field2: _(_usersI18n.messages.confirmNewPassword)
    }),
    on: ['change_password']
  }, {
    attributes: ['password'],
    condition: _validator.PASSWORD_COMPLEXITY,
    message: _(_usersI18n.messages.passwordComplexity, {
      minLength: '6'
    }),
    on: ['create', 'change_password']
  }, {
    attributes: ['confirmPassword'],
    condition: _validator.PASSWORD_COMPLEXITY,
    message: _(_usersI18n.messages.passwordComplexity, {
      minLength: '6'
    }),
    on: ['change_password']
  }];
};

var getRequiredErrorMessage = function getRequiredErrorMessage(attribute, _) {
  switch (attribute) {
    case 'email':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: _(_usersI18n.messages.email)
      }));

    case 'name':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: _(_usersI18n.messages.name)
      }));

    case 'password':
    case 'oldPassword':
    case 'confirmPassword':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: _(_usersI18n.messages.password)
      }));

    case 'roles':
      return _(_usersI18n.messages.atLeastOneRoleIsRequired);

    default:
      return null;
  }
};

var getValidationRules = function getValidationRules(scenario, _) {
  return userValidationRules(_).filter(function (rule) {
    return !rule.on || rule.on && rule.on.indexOf(scenario) !== -1;
  });
};

exports.getValidationRules = getValidationRules;
//# sourceMappingURL=validation-rules.js.map